export default "__VITE_ASSET__LNl4xMCN__"